import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { NoteDetailsPageRoutingModule } from './note-details-routing.module';

import { NoteDetailsPage } from './note-details.page';
import { QuillModule } from 'ngx-quill';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        NoteDetailsPageRoutingModule,
        QuillModule.forRoot(),
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    declarations: [NoteDetailsPage],
})
export class NoteDetailsPageModule {}
